import { Search } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import useActivityString from "../../translations/useActivityString";
import { useSearchFiltersString } from "../translations";
import BooleanFilters from "./BooleanFilters";

// NOTE: CapacityFilter in the Categories is very similar to this, consolidate it in the future.
export default function ClassSizeFilter({
  onChange,
  searchFilters,
}: {
  onChange: (value: Search.CapacityFilterType) => void;
  searchFilters: SearchFiltersType;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Search\\desktop\\ClassSizeFilter"
  );
  const { classSizeOptions } = useActivityString();
  const { getClassSizesFromCapacityFilter, getCapacityFiltersFromClassSize } =
    useSearchFiltersString();
  const sizeOptions = classSizeOptions.filter(option => option.value !== "Any");

  const selectedClassSizes = getClassSizesFromCapacityFilter(searchFilters);

  const handleFilterChange = (selectedValue: string[]) => {
    const filterValue = getCapacityFiltersFromClassSize(selectedValue);
    onChange(filterValue);
  };

  return (
    <BooleanFilters
      label={t("Size")}
      filters={sizeOptions}
      enabledFilters={selectedClassSizes}
      setEnabledFilters={handleFilterChange}
      onChange={handleFilterChange}
    />
  );
}
